// extracted by mini-css-extract-plugin
export default {"step":"styles_step__Sy5qM","ant-steps-item-container":"styles_ant-steps-item-container__Ewt09"};